import * as React from "react";
const SvgZeroHeadingShortcut = (props) => /* @__PURE__ */ React.createElement("svg", { width: "35.023109mm", height: "13.856553mm", viewBox: "0 0 35.02311 13.856553", id: "svg1", xmlSpace: "preserve", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", { id: "defs1" }, /* @__PURE__ */ React.createElement("style", { id: "style1" }, "\n      .cls-1 {\n        fill: #233c78;\n      }\n\n      .cls-2 {\n        fill: #e41e2d;\n      }\n    ")), /* @__PURE__ */ React.createElement("g", { id: "layer1", transform: "translate(-92.991479,-106.51788)" }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1.0161862,0,0,1.0161862,-21.38779,25.714709)", style: {
  display: "inline"
}, id: "g2" }, /* @__PURE__ */ React.createElement("path", { id: "left_thumbstick_back", style: {
  display: "inline",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.578634,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none"
}, d: "m 125.90392,86.334028 a 6.5286037,6.5286037 0 0 0 -6.52861,-6.528604 6.5286037,6.5286037 0 0 0 -6.5286,6.528604 6.5286037,6.5286037 0 0 0 6.5286,6.528603 6.5286037,6.5286037 0 0 0 6.52861,-6.528603 z" }), /* @__PURE__ */ React.createElement("g", { style: {
  display: "inline",
  fill: "none",
  fillOpacity: 1,
  stroke: "#ff0000",
  strokeOpacity: 1
}, transform: "matrix(0.98407163,0,0,0.98407163,1.9000284,1.3757166)", id: "g9" }, /* @__PURE__ */ React.createElement("circle", { style: {
  display: "inline",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.588,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, id: "circle12", cx: 119.37579, cy: 86.312943, r: 5.1376019, transform: "translate(0.00147702,-5.1539583e-4)" }))), /* @__PURE__ */ React.createElement("g", { transform: "translate(12.292297,27.108437)", style: {
  display: "inline",
  fill: "#e80092",
  fillOpacity: 1
}, id: "g3" }, /* @__PURE__ */ React.createElement("path", { id: "path17-1", style: {
  display: "inline",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.588,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, d: "m 108.79407,79.703443 c -3.66397,3e-5 -6.63419,2.97025 -6.63422,6.63422 3e-5,3.66397 2.97025,6.6342 6.63422,6.63423 3.66397,-3e-5 6.63419,-2.97026 6.63422,-6.63423 -3e-5,-3.66397 -2.97025,-6.63419 -6.63422,-6.63422 z" }), /* @__PURE__ */ React.createElement("g", { style: {
  display: "inline",
  fill: "none",
  fillOpacity: 1
}, transform: "translate(-10.595026)", id: "g10" }, /* @__PURE__ */ React.createElement("circle", { style: {
  display: "inline",
  fill: "none",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.588,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, id: "path1-2-3-4-3", cx: 119.37579, cy: 86.312943, r: 5.1376019, transform: "translate(0.01169299)" }))), /* @__PURE__ */ React.createElement("g", { id: "g4", transform: "matrix(1.2302379,0,0,1.2342182,-63.401376,-40.401125)", style: {
  fill: "#000000",
  fillOpacity: 1,
  strokeWidth: 0.81154
} }, /* @__PURE__ */ React.createElement("path", { style: {
  display: "inline",
  fill: "#000000",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.184442,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "m 150.94952,123.68878 q -0.098,0.13754 -0.0939,0.36749 h -0.54279 q 0.009,-0.2321 0.0755,-0.44055 0.0715,-0.18267 0.22447,-0.3374 0.11426,-0.10961 0.2714,-0.16763 0.15713,-0.058 0.38568,-0.058 0.42446,0 0.68362,0.2321 0.2612,0.22994 0.2612,0.61892 0,0.27508 -0.15509,0.46419 -0.098,0.1182 -0.20407,0.16118 0.0797,0 0.22856,0.14399 0.22243,0.21705 0.22243,0.59313 0,0.39542 -0.2612,0.69629 -0.25917,0.29871 -0.76932,0.29871 -0.62852,0 -0.8734,-0.43195 -0.12855,-0.22995 -0.14283,-0.60173 h 0.57136 q 0,0.18696 0.0571,0.30946 0.10606,0.22565 0.38567,0.22565 0.17142,0 0.29793,-0.1225 0.12857,-0.12465 0.12857,-0.35674 0,-0.30732 -0.23671,-0.41047 -0.13468,-0.058 -0.42446,-0.058 v -0.4384 q 0.28365,-0.004 0.39589,-0.058 0.19386,-0.0903 0.19386,-0.36534 0,-0.17837 -0.1,-0.29012 -0.098,-0.11174 -0.27751,-0.11174 -0.20611,0 -0.30201,0.13754 z", id: "text17", className: "cls-4" }), /* @__PURE__ */ React.createElement("path", { className: "cls-4", d: "m 149.83827,125.81472 -0.84104,-1.00555 h 0.0601 c 0.31706,-0.0802 0.58739,-0.38084 0.58739,-0.81514 0,-0.52448 -0.40383,-0.9521 -0.99456,-0.9521 h -0.76763 c -0.14351,0 -0.267,0.11692 -0.267,0.26392 v 2.6826 c 0,0.14365 0.12349,0.26724 0.267,0.26724 0.14352,0 0.26701,-0.12361 0.26701,-0.26724 v -1.04565 h 0.26366 l 1.02127,1.21268 c 0.0534,0.0668 0.12682,0.10025 0.20692,0.10025 0.14351,0 0.26366,-0.11692 0.26366,-0.26391 0,-0.0635 -0.0134,-0.11692 -0.0634,-0.17706 z m -1.14475,-1.37302 h -0.54735 v -0.90533 h 0.48394 c 0.27033,0 0.46057,0.20377 0.46057,0.45766 0,0.23052 -0.16021,0.42094 -0.4005,0.44767 z", id: "path55-9", style: {
  display: "inline",
  fill: "#000000",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.184442,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none"
}, transform: "translate(1.25e-6)" })), /* @__PURE__ */ React.createElement("g", { id: "g5", transform: "matrix(1.2234922,0,0,1.1497891,-9.4237578,-30.769967)", style: {
  fill: "#000000",
  fillOpacity: 1,
  strokeWidth: 0.843117
} }, /* @__PURE__ */ React.createElement("path", { style: {
  display: "inline",
  fill: "#000000",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.2147,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "m 106.56478,94.710332 q -0.10979,0.154104 -0.10526,0.411749 h -0.60817 q 0.01,-0.260051 0.0846,-0.493617 0.0801,-0.204669 0.25151,-0.378037 0.12803,-0.122811 0.30409,-0.187815 0.17606,-0.06501 0.43214,-0.06501 0.47558,0 0.76595,0.260053 0.29266,0.257641 0.29266,0.693468 0,0.308209 -0.17377,0.520103 -0.10978,0.132431 -0.22864,0.180591 0.0893,0 0.25609,0.161329 0.24921,0.243194 0.24921,0.664573 0,0.443052 -0.29266,0.780155 -0.29038,0.334695 -0.86198,0.334695 -0.70421,0 -0.9786,-0.483982 -0.14403,-0.257645 -0.16003,-0.674208 h 0.64018 q 0,0.209485 0.0639,0.346735 0.11884,0.252827 0.43212,0.252827 0.19206,0 0.33382,-0.137255 0.14404,-0.139661 0.14404,-0.399709 0,-0.344327 -0.26521,-0.459905 -0.15091,-0.06501 -0.47559,-0.06501 v -0.491207 q 0.31782,-0.0048 0.44357,-0.06501 0.21722,-0.101138 0.21722,-0.40934 0,-0.199854 -0.11205,-0.325065 -0.10978,-0.125202 -0.31094,-0.125202 -0.23093,0 -0.33838,0.154103 z", id: "text17-9", className: "cls-4", transform: "translate(-16.370555,29.633861)" }), /* @__PURE__ */ React.createElement("path", { className: "cls-4", d: "m 103.39595,94.293488 c 0,-0.16844 0.13836,-0.299448 0.29916,-0.299448 0.16079,0 0.29915,0.131002 0.29915,0.299448 v 2.739942 h 1.06949 c 0.15332,0 0.27299,0.123518 0.27299,0.280732 0,0.15721 -0.12337,0.280731 -0.27299,0.280731 h -1.36864 c -0.1608,0 -0.29916,-0.1385 -0.29916,-0.299446 v -2.998216 z", id: "path53-5", style: {
  display: "inline",
  fill: "#000000",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.2147,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(-16.370555,29.633861)" })), /* @__PURE__ */ React.createElement("g", { id: "g7" }, /* @__PURE__ */ React.createElement("path", { id: "rect1", style: {
  fill: "#000000",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.5,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "m 110.25303,111.69616 h 0.5 v 3.5 h -0.5 z" }), /* @__PURE__ */ React.createElement("path", { id: "rect1-6", style: {
  fill: "#000000",
  fillOpacity: 1,
  stroke: "#000000",
  strokeWidth: 0.499999,
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, d: "m 112.25303,113.19616 v 0.5 h -3.5 v -0.5 z" }))));
export default SvgZeroHeadingShortcut;
